import PosthogService from '~/services/posthog/PosthogService';

export interface IConfirmCandidateCandidateViewedPayload {
  shiftId: string;
  /** Undefined when the candidate isn't present in the counter list. */
  candidateNumber?: number;
  candidateCount: number;
  offerId: string;
  professionalId: string;
}

/**
 * Fires when an office views a candidate on the Confirm Candidate page.
 * Auto-fires for the first candidate on page load; fires on tab click for subsequent candidates.
 * Event: dental_portal:confirm_candidate:candidate_viewed
 */
export function fireConfirmCandidateCandidateViewed(
  payload: IConfirmCandidateCandidateViewedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:confirm_candidate:candidate_viewed', {
    shift_id: payload.shiftId,
    candidate_number: payload.candidateNumber,
    candidate_count: payload.candidateCount,
    offer_id: payload.offerId,
    professional_id: payload.professionalId,
  });
}
